import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-73b2c506")
const _hoisted_1 = { class: "social-networks" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialLink = _resolveComponent("SocialLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SocialLink, {
      name: "Github",
      to: "https://github.com",
      icon: "github.svg"
    }),
    _createVNode(_component_SocialLink, {
      name: "Twitter",
      to: "https://twitter.com",
      icon: "twitter.svg"
    }),
    _createVNode(_component_SocialLink, {
      name: "Facebook",
      to: "https://facebook.com",
      icon: "facebook.svg"
    })
  ]))
}